import { render, staticRenderFns } from "./cardPromocion.vue?vue&type=template&id=0761c62f&scoped=true&"
import script from "./cardPromocion.vue?vue&type=script&lang=js&"
export * from "./cardPromocion.vue?vue&type=script&lang=js&"
import style0 from "./cardPromocion.vue?vue&type=style&index=0&id=0761c62f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761c62f",
  null
  
)

export default component.exports